import { makeManifestLikeReducerActions } from '../common/actions';

const { r, a } = makeManifestLikeReducerActions('catalog');

export const reducer = r;
export const actions = a;
